/*
  Onorato · da 990 px in su i pannelli laterali di Horizon (carrello, filtri)
  si aprono sopra la pagina con un velo scuro, come nel mockup, invece di
  stringerla. Un clic sul velo chiude il pannello aperto.
  Horizon sotto i 990 px fa già così da solo (dialog modale).
*/
document.addEventListener(
  'click',
  (event) => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    if (!document.querySelector('.page-wrapper--drawer-open')) return;
    const drawer = [...document.querySelectorAll('theme-drawer')].find((d) =>
      d.querySelector(':scope > dialog[open]')
    );
    if (!drawer) return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest('dialog')) return;
    // il clic che apre il pannello (icona carrello, "+" delle card, Filtra) non deve richiuderlo:
    // Horizon lo apre prima che arrivi l'evento click
    if (target.closest('[aria-controls], [aria-haspopup="dialog"], .quick-add__button, [on\\:click*="/open"], [on\\:click*="/toggle"]')) return;
    event.preventDefault();
    event.stopPropagation();
    drawer.close();
  },
  true
);

/*
  Barra annunci: messaggio della spedizione gratuita aggiornato quando il
  carrello cambia (evento standard di Shopify usato anche da Horizon).
  Il testo di partenza arriva già giusto dal server: qui si aggiorna e basta.
*/
(() => {
  const formatMoney = (cents, format) => {
    const value = (cents / 100).toFixed(2);
    const [int, dec] = value.split('.');
    const withDots = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const withCommas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      if (key === 'amount_with_comma_separator') return `${withDots},${dec}`;
      if (key === 'amount_no_decimals_with_comma_separator') return withDots;
      if (key === 'amount_no_decimals') return withCommas;
      return `${withCommas}.${dec}`;
    });
  };
  const refresh = async () => {
    const bars = document.querySelectorAll('[data-o-shipping-bar]');
    if (!bars.length) return;
    let cart;
    try {
      cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());
    } catch {
      return;
    }
    bars.forEach((bar) => {
      const threshold = Number(bar.dataset.threshold);
      const minimum = Number(bar.dataset.minimum || 0);
      const format = bar.dataset.moneyFormat;
      let text;
      const included = (bar.dataset.includedHandles || '').split(',').filter(Boolean);
      const onlyIncluded = cart.item_count > 0 && included.length > 0 && cart.items.every((item) => included.includes(item.handle));
      if (cart.item_count === 0) text = bar.dataset.textEmpty;
      else if (onlyIncluded) text = bar.dataset.textIncluded;
      else if (minimum > 0 && cart.total_price < minimum) text = bar.dataset.textMinimum.replace('[importo]', formatMoney(minimum - cart.total_price, format));
      else if (cart.total_price < threshold) text = bar.dataset.textRemaining.replace('[importo]', formatMoney(threshold - cart.total_price, format));
      else text = bar.dataset.textReached;
      bar.textContent = text;
    });
  };
  // l'evento parte prima che il server abbia aggiornato il carrello: si aspetta la sua promise
  const onUpdate = async (event) => {
    const pending = event.promise || event.detail?.promise;
    if (pending) {
      try { await pending; } catch { /* aggiornamento fallito: si rilegge comunque */ }
    } else {
      await new Promise((resolve) => setTimeout(resolve, 600));
    }
    refresh();
  };
  document.addEventListener('shopify:cart:lines-update', onUpdate);
})();

/*
  Slideshow semplice (dissolvenza ogni 5 secondi, puntini per scegliere la foto).
  <o-slides> contiene i .o-slides__slide. Con "riduci movimento" non parte da solo.
  <o-media-slides> è un blocco dentro una sezione "Immagine con testo": prende la
  foto della sezione, ci aggiunge quelle del suo <template> e crea un <o-slides>.
*/
(() => {
  if (customElements.get('o-slides')) return;

  class OSlides extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.slides = [...this.querySelectorAll(':scope > .o-slides__slide')];
      if (this.slides.length < 2) return;
      this.ready = true;
      this.index = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));
      this.setAttribute('role', 'region');
      this.setAttribute('aria-roledescription', 'carosello');
      this.setAttribute('aria-label', this.dataset.label || 'Foto');

      const dots = document.createElement('div');
      dots.className = 'o-slides__dots';
      this.dots = this.slides.map((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'o-slides__dot';
        b.setAttribute('aria-label', `Foto ${i + 1} di ${this.slides.length}`);
        b.addEventListener('click', () => { this.show(i); this.restart(); });
        dots.append(b);
        return b;
      });
      this.append(dots);
      this.show(this.index);

      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));
      this.start();
    }
    disconnectedCallback() { this.stop(); }
    show(i) {
      const prev = this.index;
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides.forEach((s, n) => {
        const on = n === this.index;
        // la foto uscente resta piena sotto quella nuova: dissolvenza senza "buco" in mezzo
        s.classList.toggle('is-prev', !on && n === prev);
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        // le foto lazy fuori schermo vanno caricate prima di comparire
        if (on || n === (this.index + 1) % this.slides.length) s.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
      });
      this.dots?.forEach((d, n) => d.setAttribute('aria-current', n === this.index ? 'true' : 'false'));
    }
    start() {
      if (this.reduced || this.timer || !this.ready) return;
      this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) || 5000);
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    restart() { this.stop(); this.start(); }
  }

  class OMediaSlides extends HTMLElement {
    connectedCallback() {
      const section = this.closest('.media-with-content');
      const media = section?.querySelector('.media-block');
      const tpl = this.querySelector('template');
      if (!media || !tpl || media.querySelector('o-slides')) return;
      const extra = [...tpl.content.cloneNode(true).children];
      if (!extra.length) return;
      const first = media.querySelector('img, svg');
      const slides = document.createElement('o-slides');
      slides.className = 'o-slides o-slides--fill';
      if (first) {
        const slot = first.parentNode;
        const next = first.nextSibling;
        const s = document.createElement('div');
        s.className = 'o-slides__slide is-active';
        s.append(first);
        slides.append(s, ...extra);
        slot.insertBefore(slides, next);
      } else {
        extra[0].classList.add('is-active');
        slides.append(...extra);
        media.append(slides);
      }
    }
  }

  customElements.define('o-slides', OSlides);
  customElements.define('o-media-slides', OMediaSlides);
})();
